const mapStateToProps = (state) =>{
    const {
        service:{
            Api:{
                getDirectoryList,
                getPlanScheduleStatuses,
                getOrderWorkStatuses,
            }={}
        }={},
        api:{
            directoryList,
        }={},
        user:{
            rights,
        }={},
    } = state;
    return {
        getDirectoryList,
        getPlanScheduleStatuses,
        getOrderWorkStatuses,
        directoryList,
        rights,
    }
}

export default mapStateToProps;